import React from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // arrow icons

import data from '../../assets/images/assets/Delivering-Excellence-to-Transform-Businesses/Customappdevelops.png'
import production from '../../assets/images/assets/Delivering-Excellence-to-Transform-Businesses/webdevelopments.png'
import Quality from '../../assets/images/assets/Delivering-Excellence-to-Transform-Businesses/emergingdevelopments.png'

// Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <div
    className="custom-arrow next-arrow"
    onClick={onClick}
  >
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    className="custom-arrow prev-arrow"
    onClick={onClick}
  >
    <FaChevronLeft />
  </div>
);

const Image = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { 
        breakpoint: 576, 
        settings: { 
          slidesToShow: 1,
          arrows: true // enable arrows only in mobile
        } 
      },
    ],
  };

  const vrProducts = [
    { _id: 1, title:"Custom App Development", image: data },
    { _id: 2, title:"Web Development", image: production },
    { _id: 3, title:"Emerging Technology", image: Quality },
  ];

  const slideStyle = {
    backgroundColor: "#faf8f8ff",  
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    borderRadius: "10px",
  };

  const imageStyle = {
    borderRadius: "8px",
    objectFit: "contain",
  };

  return (
    <div className="slider-container px-2">
      <Slider {...settings}>
        {vrProducts.map((product) => (
          <div className="item" key={product._id}>
            <div
              style={slideStyle}
              className="d-flex flex-column align-items-center text-center mt-5"
            >
              {product.title && (
                <h3 className="mb-3 text-black fw-bold">{product.title}</h3>
              )}
              <img src={product.image} style={imageStyle} alt={product.title} />
            </div>
          </div>
        ))}
      </Slider>

    
      <style>{`
  .custom-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    z-index: 2;
    cursor: pointer;
  }
  .next-arrow {
    right: 10px;
  }
  .prev-arrow {
    left: 10px;
  }
  .custom-arrow svg {
    font-size: 18px;
    color: black;
  }

  /* 🎯 Hover animation for image */
  .slider-container img {
    transition: transform 0.5s ease, box-shadow 0.5s ease;
  }
  .slider-container img:hover {
    transform: scale(1.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }
`}</style>

    </div>
  );
};

export default Image;
